module.exports = __webpack_public_path__ + "img/list.c377dc55.svg";